// client/src/utils/mobileAuth.js - Mobile authentication helpers

import StorageManager, { STORAGE_PRIORITY } from './storageManager.js'

/**
 * Detects if the app is running in a Capacitor mobile environment.
 */
export function isMobilePlatform() {
  // Check if Capacitor global is available (injected by Capacitor runtime)
  if (typeof window !== 'undefined' && window.Capacitor !== undefined) {
    return true
  }
  // Fallback: Check environment variable set during Capacitor build
  if (process.env.REACT_APP_PLATFORM === 'mobile') {
    return true
  }
  return false
}

/**
 * Gets the auth token for mobile platforms.
 * In a full mobile implementation, this would retrieve from Capacitor Secure Storage.
 * For now, we'll get it from localStorage as a temporary solution until
 * Capacitor Secure Storage is integrated.
 */
export function getMobileAuthToken() {
  if (typeof window === 'undefined') {
    return null
  }

  try {
    // Use StorageManager for better iOS compatibility
    const token = StorageManager.get('authToken')
    return token
  } catch (error) {
    console.error('Error retrieving auth token:', error)
    return null
  }
}

/**
 * Stores the auth token for mobile platforms.
 * In a full mobile implementation, this would store in Capacitor Secure Storage.
 */
export function setMobileAuthToken(token) {
  if (typeof window === 'undefined') {
    return
  }

  try {
    if (token) {
      // Store with CRITICAL priority to prevent cleanup during quota exceeded scenarios
      const success = StorageManager.set(
        'authToken',
        token,
        STORAGE_PRIORITY.CRITICAL,
      )
      if (!success) {
        console.error(
          'Failed to store auth token - user may be logged out unexpectedly',
        )
      }
    } else {
      StorageManager.remove('authToken')
    }
  } catch (error) {
    console.error('Error storing auth token:', error)
  }
}

/**
 * Clears the stored auth token.
 */
export function clearMobileAuthToken() {
  setMobileAuthToken(null)
}
